import { AFFINE_DOC_REMOTE_SELECTION_WIDGET } from './doc';
import { AffineDocRemoteSelectionWidget } from './doc/doc-remote-selection';
import { edgelessPresenceEffects } from './viewing';

export function effects() {
  customElements.define(
    AFFINE_DOC_REMOTE_SELECTION_WIDGET,
    AffineDocRemoteSelectionWidget
  );
  edgelessPresenceEffects();
}
